import { render } from "./Verifed.vue?vue&type=template&id=cae476a0"
import script from "./Verifed.vue?vue&type=script&lang=js"
export * from "./Verifed.vue?vue&type=script&lang=js"
script.render = render

export default script